export interface BusinessExpenseKeys {
  expenseA: string
  expenseB: string
  expenseC: string
  expenseD: string
  expenseE?: string
}

export const businessExpenseKeys: Record<string, BusinessExpenseKeys> = {
  inventory: {
    expenseA: "imprecise_production",
    expenseB: "excessive_inventory",
    expenseC: "lost_revenue",
    expenseD: "excessive_scrap",
    expenseE: "premium_shipping",
  },
  medical_device: {
    expenseA: "excessive_scrap",
    expenseB: "excessive_inventory",
    expenseC: "premium_shipping",
    expenseD: "revenue_realization",
    expenseE: "shipment_disputes",
  },
  high_value: {
    expenseA: "excessive_theft",
    expenseB: "counterfeit_delivery",
    expenseC: "damage_drop",
    expenseD: "insurance_subrogation",
    expenseE: "value_added_service",
  },
  chemical: {
    expenseA: "spoilage_temperature",
    expenseB: "just_in_time",
    expenseC: "customer_penalty",
    expenseD: "improve_customer_satisfaction",
  },
  pharma: {
    expenseA: "temp_excursions",
    expenseB: "just_in_time",
    expenseC: "customer_penalty",
    expenseD: "improve_customer_satisfaction",
    expenseE: "regulatory_compliance_automated_records",
  },
  cold_chain: {
    expenseA: "product_spoilage",
    expenseB: "just_in_time",
    expenseC: "customer_penalty",
    expenseD: "improve_customer_satisfaction",
    expenseE: "shipping_insights",
  },
  asset_tracking: {
    expenseA: "inventory_availability",
    expenseB: "lost_assets",
    expenseC: "freight",
    expenseD: "maintenance_sla",
    expenseE: "regulatory_compliance",
  },
}
